import { BoxPlotDto } from '../dtos/responses/get-assignment-statistics.response.dto';

export function getBoxPlotData(stats: BoxPlotDto): number[] {
  return [
    stats.min,
    stats.percentile_25,
    stats.median, // or stats.percentile_50 (동일)
    stats.percentile_75,
    stats.max,
  ];
}
